import {liveRows} from "../../../../../helpers/matchReview";

// The row in the MatchReviewModal card shape; its rows spell the names `name`.
const contactReviewCard = (contact, investorName) => ({
    name: [contact.first_name, contact.last_name].filter(Boolean).join(' '),
    photo_url: contact.photoPreview || contact.photo_url || null,
    crd_id: contact.contact_crd_id,
    linkedin_url: contact.linkedin_url,
    gender: contact.gender,
    current_firms: investorName ? [{name: investorName, title: contact.position_name}] : [],
    achievements: contact.achievements || [],
    universities: liveRows(contact.university).map((row) => ({...row, university_name: row.name})),
    companies: liveRows(contact.company).map((row) => ({...row, company_name: row.name})),
});

export default contactReviewCard;
